/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";
import {
  SetResourceAudienceEntry,
  SetResourceAudienceEntry$Outbound,
  SetResourceAudienceEntry$outboundSchema,
} from "./setresourceaudienceentry.js";

/**
 * The kind of resource being changed.
 */
export const SetResourceAudienceFormResourceKind = {
  Mcp: "mcp",
} as const;
/**
 * The kind of resource being changed.
 */
export type SetResourceAudienceFormResourceKind = ClosedEnum<
  typeof SetResourceAudienceFormResourceKind
>;

export type SetResourceAudienceForm = {
  /**
   * The complete set of rules that name this resource. Rules covering every resource are not affected.
   */
  entries: Array<SetResourceAudienceEntry>;
  /**
   * The version this edit was based on, from the last read. The save is refused if the rules changed since.
   */
  expectedVersion: string;
  /**
   * The resource being changed.
   */
  resourceId: string;
  /**
   * The kind of resource being changed.
   */
  resourceKind: SetResourceAudienceFormResourceKind;
};

/** @internal */
export const SetResourceAudienceFormResourceKind$outboundSchema: z.ZodMiniEnum<
  typeof SetResourceAudienceFormResourceKind
> = z.enum(SetResourceAudienceFormResourceKind);

/** @internal */
export type SetResourceAudienceForm$Outbound = {
  entries: Array<SetResourceAudienceEntry$Outbound>;
  expected_version: string;
  resource_id: string;
  resource_kind: string;
};

/** @internal */
export const SetResourceAudienceForm$outboundSchema: z.ZodMiniType<
  SetResourceAudienceForm$Outbound,
  SetResourceAudienceForm
> = z.pipe(
  z.object({
    entries: z.array(SetResourceAudienceEntry$outboundSchema),
    expectedVersion: z.string(),
    resourceId: z.string(),
    resourceKind: SetResourceAudienceFormResourceKind$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      expectedVersion: "expected_version",
      resourceId: "resource_id",
      resourceKind: "resource_kind",
    });
  }),
);

export function setResourceAudienceFormToJSON(
  setResourceAudienceForm: SetResourceAudienceForm,
): string {
  return JSON.stringify(
    SetResourceAudienceForm$outboundSchema.parse(setResourceAudienceForm),
  );
}
